module.exports = __webpack_public_path__ + "static/media/drawer-close.e2b4945f.svg";